import { useSelector } from 'react-redux'
import { getJoinState, getAutoSignInPath } from './state'

import { BaseFinished } from '../Create/Finished'

export function Finished() {
  const path = useSelector(getAutoSignInPath)
  const joinState = useSelector(getJoinState)
  const error = joinState.creationError || joinState.joiningError
  return <BaseFinished path={path} error={error} />
}
